
import Vue from 'vue'
import { Prop, Component, Watch, Emit } from 'vue-property-decorator'
import { MapPostAttributes } from 'types'
import { GeoMap, LatLngLiteral, NARNIA_LATLNG } from 'bits/map'
import { MapConnection } from 'bits/map_connection'
import { getConnectorColorsFromThemeId } from 'bits/map_theme'
@Component({})
class SurfaceMapConnection extends Vue {
  private mapConnection!: MapConnection

  @Prop(Object) map!: GeoMap
  @Prop(Object) from!: MapPostAttributes
  @Prop(Object) to!: MapPostAttributes
  @Prop(String) label!: string
  @Prop(Number) labelCount!: number
  @Prop(Boolean) canDelete!: boolean
  @Prop(Number) themeId!: number

  @Watch('map')
  respondToMapChanged(map) {
    this.mapConnection.setMap(map)
  }

  @Watch('start')
  @Watch('end')
  respondToLocationChanged() {
    this.$nextTick(() => {
      if (this.start && this.end) {
        this.mapConnection.setLocation(this.start, this.end)
      }
    })
  }

  @Watch('canDelete')
  respondToCanDelete(canDelete) {
    if (canDelete) {
      this.mapConnection.showDeleteButton()
    } else {
      this.mapConnection.hideDeleteButton()
    }
  }

  @Watch('label')
  @Watch('labelCount')
  respondToLabel() {
    if (this.labelCount) {
      this.mapConnection.setLabel(String(this.labelCount))
      this.mapConnection.setLabelType('count')
    }
    if (this.label) {
      this.mapConnection.setLabel(this.label)
    }
  }

  @Watch('themeId')
  respondToThemeId() {
    const { connectorLineColor, labelBackgroundColor, labelTextColor } = getConnectorColorsFromThemeId(this.themeId)
    this.mapConnection.setColor(connectorLineColor)
    this.mapConnection.setLabelColor({
      backgroundColor: labelBackgroundColor,
      foregroundColor: labelTextColor,
    })
  }

  get start(): LatLngLiteral | null {
    if (!this.from) return null
    if (!this.from.location_point || !this.from.location_point.latitude || !this.from.location_point.longitude)
      return NARNIA_LATLNG
    return {
      lat: this.from.location_point.latitude,
      lng: this.from.location_point.longitude,
    }
  }

  get end(): LatLngLiteral | null {
    if (!this.to) return null
    if (!this.to.location_point || !this.to.location_point.latitude || !this.to.location_point.longitude)
      return NARNIA_LATLNG
    return {
      lat: this.to.location_point.latitude,
      lng: this.to.location_point.longitude,
    }
  }

  @Emit('delete')
  delete(): void {}

  mounted() {
    if (this.start && this.end) {
      this.mapConnection = new MapConnection(
        this.start,
        this.end,
        this.label || (this.labelCount && String(this.labelCount)) || '',
      )
      this.labelCount && this.mapConnection.setLabelType('count')
      this.mapConnection.addDeleteEventListener((): void => {
        this.delete()
      })
      this.mapConnection.setMap(this.map)
      if (this.canDelete) {
        this.mapConnection.showDeleteButton()
      } else {
        this.mapConnection.hideDeleteButton()
      }
    }
    const { connectorLineColor, labelBackgroundColor, labelTextColor } = getConnectorColorsFromThemeId(this.themeId)
    this.mapConnection.setColor(connectorLineColor)
    this.mapConnection.setLabelColor({
      backgroundColor: labelBackgroundColor,
      foregroundColor: labelTextColor,
    })
  }

  beforeDestroy() {
    this.mapConnection.destroy()
  }

  render() {
    // Does not render any DOM node
    return null
  }
}
export default SurfaceMapConnection
